import swal from 'sweetalert';

const defaultSwalOptions = {
    title: 'Info',
    icon: 'info',
};

function displayInfo(swalOptionsFact) {
    function displayInfoAction({ props }) {
        const options = { ...defaultSwalOptions, ...swalOptionsFact(props) };
        if (options.html) {
            options.content = {
                element: 'div',
                attributes: {
                    innerHTML: options.html,
                },
            };
        }

        swal(options);
    }

    return displayInfoAction;
}

export default displayInfo;
